import { useMutation } from 'react-query';
import { trpc } from '../../../lib/trpc';

const useDeletePropertyDocument = () => {
    return useMutation(async ({ documentId, propertyId }: { documentId: number; propertyId: number }) => {
        return await trpc.BindersApi.removePropertyDocument.mutate({ id: documentId, propertyId });
    });
};

export default useDeletePropertyDocument;
